export default __webpack_public_path__ + "static/media/IMG_7019.7d761e15.webp";